import { mapGetters } from "vuex";
import { isSmallDevice } from "@/common/functions";

export default {
    name: "Advertising",
    data() {
        return {
            isMobileLeaderboard: false
        };
    },
    methods: {
        onWindowResize() {
            const viewportHeight = window.visualViewport.height;
            if (this.screenWindow.visibleHeight !== viewportHeight) {
                this.$store.commit("Screen/updateVisibleHeight", viewportHeight);
            }
        },

        onWindowScroll() {
            const viewportScroll = window.visualViewport.offsetTop;
            if (this.screenWindow.visibleScroll !== viewportScroll && viewportScroll >= 0) {
                this.$store.commit("Screen/updateVisibleScroll", viewportScroll);
            }
        }
    },
    computed: {
        ...mapGetters("Screen", ["inputHasFocus", "screenWindow"]),
        outerElementInlineStyle() {
            const s = {};

            /**
             * On iOS Safari, the keyboard overlaps on top of the layout viewport,
             * which means that window.innerHeight won't return the correct value.
             * In that case, we need to calculate the difference using the visual
             * viewport (which is the layout viewport minus the keyboard), and adjust the position of the ad accordingly.
             */
            if (
                this.isMobileLeaderboard &&
                typeof window.visualViewport === "object" &&
                this.inputHasFocus
            ) {
                s.bottom = "auto";

                const scrollY = this.screenWindow.visibleScroll;
                const windowHeight = this.screenWindow.visibleHeight;
                const adHeight = 50;

                s.top = `${windowHeight + scrollY - adHeight}px`;
                s.position = "fixed";
            }

            return s;
        }
    },
    mounted() {
        this.isMobileLeaderboard = this.$el.classList.contains("anchor-ad") && isSmallDevice();
    },
    created() {
        if (typeof window.__PRERENDER_INJECTED === "undefined") {
            this.onWindowResize();
            this.onWindowScroll();

            const w = window.visualViewport;
            w.addEventListener("resize", this.onWindowResize);
            w.addEventListener("scroll", this.onWindowScroll);
        }
    },
    destroyed() {
        const w = window.visualViewport;
        w.removeEventListener("resize", this.onWindowResize);
        w.removeEventListener("scroll", this.onWindowScroll);
    }
};



// WEBPACK FOOTER //
// ./src/components/Advertising/Advertising.js